import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { AAT_OPTIONS, AMU_OPTIONS, vitalUnitListEmpty, vitalUnitListMetric, vitalUnitListUS } from "../../Components/Constants";
import PracticeDetailsPrintPopup from "../../Components/PracticeDetailsPrintPopup";
import FormatPhoneNumber from "../../../../../../../../../utils/FormatPhoneNumber";
import SignImagePreview from "../../Components/SignImagePreview";
import { formatDateTimeWithAt } from "../../Components/FormatDateTimeWithAt";
import { renderLeftRight } from "./utils";
import ProblemAreaPreview from "./ObjectiveSections/ProblemAreaPreview";
// import { HPI_GROUPS, ROS_GROUPS } from "../../Components/utils";
import CustomTemplateFormPreview from "../../Components/Custom Template Form/CustomTemplateFormPreview";
import EncDateStatus from "../../Components/Encounter Print Popup/EncDateStatus";
import SignData from "../../Components/SignData";
import { isSignedOrToBeCoSigned } from "../../Components/utils";

const SelectedPreviewDataV2 = ({ selectedItems, data, Data, searchParam, searchValue, ...props }) => {
    let { showAddressTypeLocation } = props;
    console.log("showAddressTypeLocation", showAddressTypeLocation)
    // let DropDowns = useSelector(state => state.GeneralDropDownsReducer);

    let { RangeOfMotion: rangeOfMotion, Strength: strength } = { ...Data };
    // let systemVitals = data?.Vital?.[0]?.Vital?.reduce((acc, curr) => {
    //     acc[curr.VitalName] = curr.VitalValue;
    //     return acc;
    // }, {});
    // let vitalData = Data?.vitalData?.reduce((acc, curr) => {
    //     acc[curr.VitalName] = curr.VitalValue || systemVitals?.[curr.VitalName];
    //     return acc;
    // }, {});

    const isVisuallyEmpty = (html = '') => {
        return html.replace(/<[^>]*>/g, '').trim() === '';
    }

    const removeTrailingEmptyLines = (html) => {
        return html.replace(/(<p><br><\/p>\s*)+$/g, '');
    }

    let noValExistTextNA = <p className="text ar-light-color">N/A</p>;
    // let noValExistVitalTextNA = <span className="text ar-light-color">N/A</span>;
    let noValExistText = <p className="text ar-light-color">No data recorded</p>;
    console.log("AssesmentNotesAssesmentNotes", Data)

    let subjectiveNoteText = removeTrailingEmptyLines(Data?.SubjectiveNotes || '');
    // let palpationNoteText = removeTrailingEmptyLines(objectiveFinding?.PalpationNotes || '');
    let observationNoteText = removeTrailingEmptyLines(Data?.ObservationNotes || '');
    let palpationNoteText = removeTrailingEmptyLines(Data?.PalpationNotes || '');
    let testMeasurementNoteText = removeTrailingEmptyLines(Data?.TestMeasurementNotes || '');

    let objectiveNoteText = removeTrailingEmptyLines(Data?.ObjectiveNotes || '');
    let focusAreaNoteText = removeTrailingEmptyLines(Data?.AssessmentAreaTreated?.AAT_FocusArea || '');
    let assesmentNoteText = removeTrailingEmptyLines(Data?.AssesmentNotes || '');
    let planNoteText = removeTrailingEmptyLines(Data?.PlanNotes || '');
    let homeExerciseProgramNoteText = removeTrailingEmptyLines(Data?.HomeExerciseProgram || '');
    let followUpNotesText = removeTrailingEmptyLines(Data?.FollowUpNotes || '');
    let additionalNoteText = removeTrailingEmptyLines(Data?.AdditionalInfoNotes || '');

    const vitalUnitListPreview = useMemo(() => {
        if (searchParam?.VitalUnitType === "US Customary") {
            return vitalUnitListUS;
        } else if (searchParam?.VitalUnitType === "Metric") {
            return vitalUnitListMetric;
        }
        return vitalUnitListEmpty; // fallback empty object
    }, [searchParam?.VitalUnitType]);
    console.log("data Data 123", data, Data,)

    const formattedUTC = data?.Data?.CurrentPracticeTime;
    let signatureDateTimeFormatted = formatDateTimeWithAt(data?.Data?.ProviderSignatureDate)
    let formattedUTCBottom = formattedUTC?.replace(',', ' at');
    const CustomTemplateData = Data?.CustomTemplateData?.[0];
    const EncounterCoSignData = Data?.EncounterCoSignData?.filter(enc => [ true, "true"].includes(enc.isCoSigned));

        const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (<>
        {/* {selectedItems?.patientSummary && */}
        <div className='d-flex flex-column gap-10 mb-15'>
            {/* <div className="d-flex align-items-center justify-content-between pb-1-5 br-bottom-1 za_br_light">
                    <p className="text fs-11 ar-light-color">{formattedUTC}</p>
                    <p className='text fs-11 ar-light-color'>{data?.Data?.UserName ? `(${data?.Data?.UserName})` : ''} {data?.Data?.PracticeShortName}</p>
                </div> */}
            <div className="d-flex align-items-center justify-content-center gap-12 pat-det-header">
                <div className="d-flex align-items-center gap-1">
                    <p className='heading text-white'>{data?.Data?.PatientName}</p>
                    <p className='text text-white'>{data?.Data?.DOB}</p>
                    <p className='text text-white'>{data?.Data?.Age ? `(${data?.Data?.Age})` : ''}</p>
                    <p className='text text-white'>{data?.Data?.Gender}</p>
                </div>
                <div className="text light-clrs">|</div>
                <div className="d-flex align-items-center gap-1">
                    <p className='text font-m text-white'>Account #</p>
                    <p className="text text-white">{data?.Data?.AccountNumber || noValExistTextNA}</p>
                </div>
                <div className="text light-clrs">|</div>
                <div className="d-flex align-items-center gap-1">
                    <p className='text font-m text-white'>DOS:</p>
                    <p className="text text-white">{searchParam?.EncounterDate || noValExistTextNA}</p>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-between">
                {console.log("dataqwertData", data?.Data)}
                <PracticeDetailsPrintPopup data={data?.Data} />
            </div>
            <div className=''>
                <div className="encounter-edit-mode-pdf p-2 d-flex flex-column gap-1">
                    <div className="col-md-12 p-0 d-flex gap-1">
                        <p className="heading validate-color fs-16 lh-15">{data?.Data?.PatientName}</p>
                        <span className='d-flex gap-1 align-items-center'>
                            <span className='text text-black'>{data?.Data?.DOB}</span> <span className='text text-black'>{data?.Data?.Age ? `(${data?.Data?.Age})` : ''}</span> <span className='text text-black'>{data?.Data?.Gender}</span>
                        </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-column gap-1">
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Account #</p>
                                <p className="text text-black">{data?.Data?.AccountNumber || noValExistTextNA}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Phone:</p>
                                <p className="text text-black">{data?.Data?.MobileNumber ? FormatPhoneNumber(data?.Data?.MobileNumber) : noValExistTextNA}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Address:</p>
                                <p className="text text-black">
                                    {selectedItems?.patientSummary ?
                                        (([true, "true"].includes(showAddressTypeLocation) ?
                                            data?.Data?.FacilityAddress : data?.Data?.Address)
                                            || noValExistTextNA) : noValExistTextNA}
                                </p>
                            </div>
                        </div>

                        <div className="d-flex flex-column gap-1">
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Provider:</p>
                                <p className="heading validate-color">{searchValue.SeenBy || noValExistTextNA}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Insurance:</p>
                                <p className="text text-black">{data?.Data?.InsuranceName || noValExistTextNA}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Location:</p>
                                <p className="text text-black">{searchValue?.Facility || noValExistTextNA}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-between">
                <EncDateStatus searchParam={searchParam} searchValue={searchValue} noValExistTextNA={noValExistTextNA} data={data} Data={Data}/>

                <div className="d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center gap-1">
                        <p className="heading validate-color">Encounter Type:</p>
                        {searchValue?.EncounterType ?
                            <span className="text validate-color">{searchValue.EncounterType}</span>
                            :
                            <>{noValExistTextNA}</>}
                    </div>

                    <div className="d-flex align-items-center gap-1">
                        <p className="heading validate-color">Note Type:</p>
                        {searchValue?.NoteType ?
                            <span className="text validate-color">{searchValue.NoteType}</span>
                            :
                            <>{noValExistTextNA}</>}
                    </div>
                </div>
                {/* {searchValue?.EncounterType && searchValue?.NoteType && <span> - </span>}
                        {searchValue?.NoteType && <span>{searchValue.NoteType}:</span>} */}
                {/* {searchValue?.SeenBy && <span> {searchValue.SeenBy}</span>} */}

            </div>

        </div>
        {/* } */}
        <div className="d-flex flex-column gap-10">
            {selectedItems?.customTemplateClinical &&
                (CustomTemplateData?.InsertPosition === "Top" ?
                    <CustomTemplateFormPreview CustomTemplateData={CustomTemplateData}/> : <></>)}
            {selectedItems?.chiefComplaint &&
                <div>
                    <div className="d-flex flex-column gap-6">
                        <div className="d-flex">
                            <p className='text fs-14 font-b validate-color blue-bg'>Chief Complaint</p>
                        </div>
                        <p className="text text-black">{Data?.ChiefComplaint || noValExistText}</p>
                    </div>
                </div>}
            {selectedItems?.problems &&
                <div>
                    <div className="d-flex flex-column gap-6">
                        <div className="d-flex">
                            <p class="text fs-14 font-b validate-color blue-bg">Problems</p>
                        </div>


                        {Data?.EncounterProblem?.length > 0 ?

                            <div className="d-flex flex-column gap-1">
                                {Data.EncounterProblem.map((prob) => (
                                    <div className="d-flex align-items-center gap-1">
                                        <p className='text font-m validate-color'>{prob.DiagnosisCode}</p>
                                        <p className="text text-black">{prob.Description && `- ${prob.Description}${prob.StartDate ? ',' : ''}`}</p>
                                        {prob.StartDate ?
                                            (<div className="d-flex align-items-center gap-1">
                                                <p className='heading text-black'>Start Date:</p>
                                                <p className='text text-black'>{prob.StartDate || <span className="text fs-11 ar-light-color fst-italic">N/A</span>}</p>
                                            </div>) : <></>}
                                    </div>
                                )
                                )}
                            </div> :
                            <>{noValExistText}</>}
                    </div>
                </div>}

            {selectedItems?.subjectiveNotes &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">SUBJECTIVE</p>
                    </div>
                    <div>
                        {isVisuallyEmpty(subjectiveNoteText) ?
                            noValExistText :
                            <p className="text text-black" dangerouslySetInnerHTML={{ __html: subjectiveNoteText }}></p>}
                    </div>
                </div>}
            {(selectedItems?.objective || (selectedItems?.observationNotes || selectedItems?.palpationNotes || selectedItems?.rangeOfMotion || selectedItems?.strength || selectedItems?.testMeasurementNotes || selectedItems?.objectiveNotes)) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">OBJECTIVE</p>
                    </div>
                    {selectedItems?.observationNotes &&
                    <div>
                        <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Observations</p>
                        <div>
                            {isVisuallyEmpty(Data.ObservationNotes) ?
                            noValExistText :
                            <p className="text text-black" dangerouslySetInnerHTML={{ __html: observationNoteText }}></p>}
                        </div>
                    </div>}
                    {selectedItems?.problemArea &&
                    <div>
                        <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Problem Area</p>
                        <div>
                            <ProblemAreaPreview 
                                FrontBodyDiagram= {Data?.FrontBodyDiagram || []}
                                BackBodyDiagram= {Data?.BackBodyDiagram || []}
                            />
                        </div>
                    </div>}
                    {selectedItems?.palpationNotes &&
                    <div>
                        <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Palpation</p>
                        <div>
                            {isVisuallyEmpty(Data.PalpationNotes) ?
                            noValExistText :
                            <p className="text text-black" dangerouslySetInnerHTML={{ __html: palpationNoteText }}></p>}
                        </div>
                    </div>}
                    {/* ////////////////// */}
                    {selectedItems?.rangeOfMotion &&
                        <>
                        <div className="">
                            <p className='heading fs-13 text-decoration-underline letter-spacing-1-3 pb-1'>Range of Motion (ROM):</p>
                            {(rangeOfMotion?.PT_ROM_CervicalSpine === "true" ||
                            rangeOfMotion?.PT_ROM_ThoracicLumbarSpine === "true" ||
                            rangeOfMotion?.PT_ROM_Shoulder === "true" ||
                            rangeOfMotion?.PT_ROM_Elbow === "true" ||
                            rangeOfMotion?.PT_ROM_Forearm === "true" ||
                            rangeOfMotion?.PT_ROM_Wrist === "true" ||
                            rangeOfMotion?.PT_ROM_Hip === "true" ||
                            rangeOfMotion?.PT_ROM_Knee === "true" ||
                            rangeOfMotion?.PT_ROM_Ankle === "true") &&
                            <div className="d-flex align-items-center gap-12 row-gap-5 flex-wrap">
                                {rangeOfMotion?.PT_ROM_CervicalSpine === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Cervical Spine</p>
                                </div>}
        
                                {rangeOfMotion?.PT_ROM_ThoracicLumbarSpine === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Thoracic & Lumbar Spine</p>
                                </div>}
        
                                {rangeOfMotion?.PT_ROM_Shoulder === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Shoulder</p>
                                </div>}
        
                                {rangeOfMotion?.PT_ROM_Elbow === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Elbow</p>
                                </div>}
        
                                {rangeOfMotion?.PT_ROM_Forearm === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Forearm</p>
                                </div>}
        
                                {rangeOfMotion?.PT_ROM_Wrist === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Wrist</p>
                                </div>}
        
                                {rangeOfMotion?.PT_ROM_Hip === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Hip</p>
                                </div>}
        
                                {rangeOfMotion?.PT_ROM_Knee === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Knee</p>
                                </div>}
        
                                {rangeOfMotion?.PT_ROM_Ankle === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Ankle</p>
                                </div>}
                            </div>}
                            {!(rangeOfMotion?.PT_ROM_CervicalSpine === "true" ||
                            rangeOfMotion?.PT_ROM_ThoracicLumbarSpine === "true" ||
                            rangeOfMotion?.PT_ROM_Shoulder === "true" ||
                            rangeOfMotion?.PT_ROM_Elbow === "true" ||
                            rangeOfMotion?.PT_ROM_Forearm === "true" ||
                            rangeOfMotion?.PT_ROM_Wrist === "true" ||
                            rangeOfMotion?.PT_ROM_Hip === "true" ||
                            rangeOfMotion?.PT_ROM_Knee === "true" ||
                            rangeOfMotion?.PT_ROM_Ankle === "true") && noValExistText}
                        </div>
                        {/* Cervical Spine ROM */}
                        {rangeOfMotion?.PT_ROM_CervicalSpine === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Cervical Spine ROM</p>
                                {rangeOfMotion?.PT_ROM_CS_Flexion ?
                                <div className="d-flex align-items-center gap-01">
                                    <p className="heading ar_dot align-items-center d-flex gap-1">Flexion:</p>
                                    <p className="text">{rangeOfMotion?.PT_ROM_CS_Flexion || noValExistTextNA}</p>
                                </div> : <></>}
                                {rangeOfMotion?.PT_ROM_CS_Extension ?
                                <div className="d-flex align-items-center gap-01">
                                    <p className="heading ar_dot align-items-center d-flex gap-1">Extension:</p>
                                    <p className="text">{rangeOfMotion?.PT_ROM_CS_Extension || noValExistTextNA}</p>
                                </div> : <></>}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_CS_LateralFlexionLeft, rangeOfMotion?.PT_ROM_CS_LateralFlexionRight, 'Lateral Flexion')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_CS_RotationLeft, rangeOfMotion?.PT_ROM_CS_RotationRight, 'Rotation')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{rangeOfMotion?.PT_ROM_CS_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Thoracic & Lumbar Spine ROM */}
                        {rangeOfMotion?.PT_ROM_ThoracicLumbarSpine === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Thoracic & Lumbar Spine ROM</p>
                                {rangeOfMotion?.PT_ROM_TLS_Flexion ?
                                <div className="d-flex align-items-center gap-01">
                                    <p className="heading ar_dot align-items-center d-flex gap-1">Flexion:</p>
                                    <p className="text">{rangeOfMotion?.PT_ROM_TLS_Flexion || noValExistTextNA}</p>
                                </div> : <></>}
                                {rangeOfMotion?.PT_ROM_TLS_Extension ?
                                <div className="d-flex align-items-center gap-01">
                                    <p className="heading ar_dot align-items-center d-flex gap-1">Extension:</p>
                                    <p className="text">{rangeOfMotion?.PT_ROM_TLS_Extension || noValExistTextNA}</p>
                                </div> : <></>}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_TLS_LateralFlexionLeft, rangeOfMotion?.PT_ROM_TLS_LateralFlexionRight, 'Lateral Flexion')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_TLS_RotationLeft, rangeOfMotion?.PT_ROM_TLS_RotationRight, 'Rotation')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{rangeOfMotion?.PT_ROM_TLS_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Shoulder */}
                        {rangeOfMotion?.PT_ROM_Shoulder === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Shoulder ROM</p>
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Shoulder_FlexionLeft, rangeOfMotion?.PT_ROM_Shoulder_FlexionRight, 'Flexion')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Shoulder_ExtensionLeft, rangeOfMotion?.PT_ROM_Shoulder_ExtensionRight, 'Extension')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Shoulder_AbductionLeft, rangeOfMotion?.PT_ROM_Shoulder_AbductionRight, 'Abduction')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Shoulder_AdductionLeft, rangeOfMotion?.PT_ROM_Shoulder_AdductionRight, 'Adduction')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Shoulder_InternalRotationLeft, rangeOfMotion?.PT_ROM_Shoulder_InternalRotationRight, 'Internal Rotation')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Shoulder_ExternalRotationLeft, rangeOfMotion?.PT_ROM_Shoulder_ExternalRotationRight, 'External Rotation')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{rangeOfMotion?.PT_ROM_Shoulder_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Elbow */}
                        {rangeOfMotion?.PT_ROM_Elbow === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Elbow ROM</p>
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Elbow_FlexionLeft, rangeOfMotion?.PT_ROM_Elbow_FlexionRight, 'Flexion')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Elbow_ExtensionLeft, rangeOfMotion?.PT_ROM_Elbow_ExtensionRight, 'Extension')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{rangeOfMotion?.PT_ROM_Elbow_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Forearm */}
                        {rangeOfMotion?.PT_ROM_Forearm === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Forearm  ROM</p>
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Forearm_PronationLeft, rangeOfMotion?.PT_ROM_Forearm_PronationRight, 'Pronation')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Forearm_SupinationLeft, rangeOfMotion?.PT_ROM_Forearm_SupinationRight, 'Supination')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{rangeOfMotion?.PT_ROM_Forearm_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Wrist */}
                        {rangeOfMotion?.PT_ROM_Wrist === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Wrist ROM</p>
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Wrist_FlexionLeft, rangeOfMotion?.PT_ROM_Wrist_FlexionRight, 'Flexion')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Wrist_ExtensionLeft, rangeOfMotion?.PT_ROM_Wrist_ExtensionRight, 'Extension')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Wrist_RadialDeviationLeft, rangeOfMotion?.PT_ROM_Wrist_RadialDeviationRight, 'Radial Deviation')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Wrist_UlnarDeviationLeft, rangeOfMotion?.PT_ROM_Wrist_UlnarDeviationRight, 'Ulnar Deviation')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{rangeOfMotion?.PT_ROM_Wrist_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Hip */}
                        {rangeOfMotion?.PT_ROM_Hip === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Hip ROM</p>
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Hip_FlexionLeft, rangeOfMotion?.PT_ROM_Hip_FlexionRight, 'Flexion')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Hip_ExtensionLeft, rangeOfMotion?.PT_ROM_Hip_ExtensionRight, 'Extension')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Hip_AbductionLeft, rangeOfMotion?.PT_ROM_Hip_AbductionRight, 'Abduction')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Hip_AdductionLeft, rangeOfMotion?.PT_ROM_Hip_AdductionRight, 'Adduction')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Hip_InternalRotationLeft, rangeOfMotion?.PT_ROM_Hip_InternalRotationRight, 'Internal Rotation')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Hip_ExternalRotationLeft, rangeOfMotion?.PT_ROM_Hip_ExternalRotationRight, 'External Rotation')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{rangeOfMotion?.PT_ROM_Hip_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Knee */}
                        {rangeOfMotion?.PT_ROM_Knee === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Knee ROM</p>
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Knee_FlexionLeft, rangeOfMotion?.PT_ROM_Knee_FlexionRight, 'Flexion')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Knee_ExtensionLeft, rangeOfMotion?.PT_ROM_Knee_ExtensionRight, 'Extension')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{rangeOfMotion?.PT_ROM_Knee_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Ankle */}
                        {rangeOfMotion?.PT_ROM_Ankle === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Ankle ROM</p>
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Ankle_PlantarflexionLeft, rangeOfMotion?.PT_ROM_Ankle_PlantarflexionRight, 'Plantarflexion')}
                                {renderLeftRight(rangeOfMotion?.PT_ROM_Ankle_DorsiflexionLeft, rangeOfMotion?.PT_ROM_Ankle_DorsiflexionRight, 'Dorsiflexion')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{rangeOfMotion?.PT_ROM_Ankle_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        </>}
                    {selectedItems?.strength &&
                        <>
                        <div className="">
                            <p className='heading fs-13 text-decoration-underline letter-spacing-1-3 pb-1'>Strength:</p>
                            {(strength?.PT_Str_CervicalSpine === "true" ||
                            strength?.PT_Str_ThoracicLumbarSpine === "true" ||
                            strength?.PT_Str_Shoulder === "true" ||
                            strength?.PT_Str_Elbow === "true" ||
                            strength?.PT_Str_Forearm === "true" ||
                            strength?.PT_Str_Wrist === "true" ||
                            strength?.PT_Str_Hip === "true" ||
                            strength?.PT_Str_Knee === "true" ||
                            strength?.PT_Str_Ankle === "true") &&
                            <div className="d-flex align-items-center gap-12 row-gap-5 flex-wrap">
                                {strength?.PT_Str_CervicalSpine === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Cervical Spine</p>
                                </div>}
        
                                {strength?.PT_Str_ThoracicLumbarSpine === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Thoracic & Lumbar Spine</p>
                                </div>}
        
                                {strength?.PT_Str_Shoulder === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Shoulder</p>
                                </div>}
        
                                {strength?.PT_Str_Elbow === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Elbow</p>
                                </div>}
        
                                {strength?.PT_Str_Forearm === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Forearm</p>
                                </div>}
        
                                {strength?.PT_Str_Wrist === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Wrist</p>
                                </div>}
        
                                {strength?.PT_Str_Hip === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Hip</p>
                                </div>}
        
                                {strength?.PT_Str_Knee === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Knee</p>
                                </div>}
        
                                {strength?.PT_Str_Ankle === "true" &&
                                <div className="d-flex align-items-center gap-6 blue-tick">
                                    <i className="icon-check fs-15 fw-900"></i>
                                    <p className="text">Ankle</p>
                                </div>}
                            </div>}
                            {!(strength?.PT_Str_CervicalSpine === "true" ||
                            strength?.PT_Str_ThoracicLumbarSpine === "true" ||
                            strength?.PT_Str_Shoulder === "true" ||
                            strength?.PT_Str_Elbow === "true" ||
                            strength?.PT_Str_Forearm === "true" ||
                            strength?.PT_Str_Wrist === "true" ||
                            strength?.PT_Str_Hip === "true" ||
                            strength?.PT_Str_Knee === "true" ||
                            strength?.PT_Str_Ankle === "true") && noValExistText}
                        </div>
                        {/* Cervical Spine Strength */}
                        {strength?.PT_Str_CervicalSpine === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Cervical Spine Strength</p>
                                {strength?.PT_Str_CS_Flexion ?
                                <div className="d-flex align-items-center gap-01">
                                    <p className="heading ar_dot align-items-center d-flex gap-1">Flexion:</p>
                                    <p className="text">{strength?.PT_Str_CS_Flexion || noValExistTextNA}</p>
                                </div> : <></>}
                                {strength?.PT_Str_CS_Extension ?
                                <div className="d-flex align-items-center gap-01">
                                    <p className="heading ar_dot align-items-center d-flex gap-1">Extension:</p>
                                    <p className="text">{strength?.PT_Str_CS_Extension || noValExistTextNA}</p>
                                </div> : <></>}
                                {renderLeftRight(strength?.PT_Str_CS_LateralFlexionLeft, strength?.PT_Str_CS_LateralFlexionRight, 'Lateral Flexion')}
                                {renderLeftRight(strength?.PT_Str_CS_RotationLeft, strength?.PT_Str_CS_RotationRight, 'Rotation')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{strength?.PT_Str_CS_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Thoracic & Lumbar Spine Strength */}
                        {strength?.PT_Str_ThoracicLumbarSpine === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Thoracic & Lumbar Spine Strength</p>
                                {strength?.PT_Str_TLS_Flexion ?
                                <div className="d-flex align-items-center gap-01">
                                    <p className="heading ar_dot align-items-center d-flex gap-1">Flexion:</p>
                                    <p className="text">{strength?.PT_Str_TLS_Flexion || noValExistTextNA}</p>
                                </div> : <></>}
                                {strength?.PT_Str_TLS_Extension ?
                                <div className="d-flex align-items-center gap-01">
                                    <p className="heading ar_dot align-items-center d-flex gap-1">Extension:</p>
                                    <p className="text">{strength?.PT_Str_TLS_Extension || noValExistTextNA}</p>
                                </div> : <></>}
                                {renderLeftRight(strength?.PT_Str_TLS_LateralFlexionLeft, strength?.PT_Str_TLS_LateralFlexionRight, 'Lateral Flexion')}
                                {renderLeftRight(strength?.PT_Str_TLS_RotationLeft, strength?.PT_Str_TLS_RotationRight, 'Rotation')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{strength?.PT_Str_TLS_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Shoulder */}
                        {strength?.PT_Str_Shoulder === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Shoulder Strength</p>
                                {renderLeftRight(strength?.PT_Str_Shoulder_FlexionLeft, strength?.PT_Str_Shoulder_FlexionRight, 'Flexion')}
                                {renderLeftRight(strength?.PT_Str_Shoulder_ExtensionLeft, strength?.PT_Str_Shoulder_ExtensionRight, 'Extension')}
                                {renderLeftRight(strength?.PT_Str_Shoulder_AbductionLeft, strength?.PT_Str_Shoulder_AbductionRight, 'Abduction')}
                                {renderLeftRight(strength?.PT_Str_Shoulder_AdductionLeft, strength?.PT_Str_Shoulder_AdductionRight, 'Adduction')}
                                {renderLeftRight(strength?.PT_Str_Shoulder_InternalRotationLeft, strength?.PT_Str_Shoulder_InternalRotationRight, 'Internal Rotation')}
                                {renderLeftRight(strength?.PT_Str_Shoulder_ExternalRotationLeft, strength?.PT_Str_Shoulder_ExternalRotationRight, 'External Rotation')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{strength?.PT_Str_Shoulder_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Elbow */}
                        {strength?.PT_Str_Elbow === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Elbow Strength</p>
                                {renderLeftRight(strength?.PT_Str_Elbow_FlexionLeft, strength?.PT_Str_Elbow_FlexionRight, 'Flexion')}
                                {renderLeftRight(strength?.PT_Str_Elbow_ExtensionLeft, strength?.PT_Str_Elbow_ExtensionRight, 'Extension')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{strength?.PT_Str_Elbow_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Forearm */}
                        {strength?.PT_Str_Forearm === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Forearm  Strength</p>
                                {renderLeftRight(strength?.PT_Str_Forearm_PronationLeft, strength?.PT_Str_Forearm_PronationRight, 'Pronation')}
                                {renderLeftRight(strength?.PT_Str_Forearm_SupinationLeft, strength?.PT_Str_Forearm_SupinationRight, 'Supination')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{strength?.PT_Str_Forearm_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Wrist */}
                        {strength?.PT_Str_Wrist === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Wrist Strength</p>
                                {renderLeftRight(strength?.PT_Str_Wrist_FlexionLeft, strength?.PT_Str_Wrist_FlexionRight, 'Flexion')}
                                {renderLeftRight(strength?.PT_Str_Wrist_ExtensionLeft, strength?.PT_Str_Wrist_ExtensionRight, 'Extension')}
                                {renderLeftRight(strength?.PT_Str_Wrist_RadialDeviationLeft, strength?.PT_Str_Wrist_RadialDeviationRight, 'Radial Deviation')}
                                {renderLeftRight(strength?.PT_Str_Wrist_UlnarDeviationLeft, strength?.PT_Str_Wrist_UlnarDeviationRight, 'Ulnar Deviation')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{strength?.PT_Str_Wrist_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Hip */}
                        {strength?.PT_Str_Hip === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Hip Strength</p>
                                {renderLeftRight(strength?.PT_Str_Hip_FlexionLeft, strength?.PT_Str_Hip_FlexionRight, 'Flexion')}
                                {renderLeftRight(strength?.PT_Str_Hip_ExtensionLeft, strength?.PT_Str_Hip_ExtensionRight, 'Extension')}
                                {renderLeftRight(strength?.PT_Str_Hip_AbductionLeft, strength?.PT_Str_Hip_AbductionRight, 'Abduction')}
                                {renderLeftRight(strength?.PT_Str_Hip_AdductionLeft, strength?.PT_Str_Hip_AdductionRight, 'Adduction')}
                                {renderLeftRight(strength?.PT_Str_Hip_InternalRotationLeft, strength?.PT_Str_Hip_InternalRotationRight, 'Internal Rotation')}
                                {renderLeftRight(strength?.PT_Str_Hip_ExternalRotationLeft, strength?.PT_Str_Hip_ExternalRotationRight, 'External Rotation')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{strength?.PT_Str_Hip_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Knee */}
                        {strength?.PT_Str_Knee === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Knee Strength</p>
                                {renderLeftRight(strength?.PT_Str_Knee_FlexionLeft, strength?.PT_Str_Knee_FlexionRight, 'Flexion')}
                                {renderLeftRight(strength?.PT_Str_Knee_ExtensionLeft, strength?.PT_Str_Knee_ExtensionRight, 'Extension')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{strength?.PT_Str_Knee_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        {/* Ankle */}
                        {strength?.PT_Str_Ankle === "true" &&
                            <div className="d-flex flex-column gap-1">
                            <div className="">
                                <p className="heading pb-2px">Ankle Strength</p>
                                {renderLeftRight(strength?.PT_Str_Ankle_PlantarflexionLeft, strength?.PT_Str_Ankle_PlantarflexionRight, 'Plantarflexion')}
                                {renderLeftRight(strength?.PT_Str_Ankle_DorsiflexionLeft, strength?.PT_Str_Ankle_DorsiflexionRight, 'Dorsiflexion')}
                            </div>
                            <div className="">
                                <p className="heading">Notes :</p>
                                <p className="text">{strength?.PT_Str_Ankle_Notes || noValExistTextNA}</p>
                            </div>
                            </div>}
                        </>}
                    {/* //////////////////// */}
                    {selectedItems?.testMeasurementNotes &&
                    <div>
                        <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Tests & Measurements(Sensory, Special Tests)</p>
                        <div>
                            {isVisuallyEmpty(Data.TestMeasurementNotes) ?
                                noValExistText :
                                <p className="text text-black" dangerouslySetInnerHTML={{ __html: testMeasurementNoteText || '' }}></p>}
                        </div>
                    </div>}
                    {selectedItems?.objectiveNotes &&
                    <div>
                        <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                        <div>
                            {isVisuallyEmpty(objectiveNoteText) ?
                                noValExistText :
                                <p className="text text-black" dangerouslySetInnerHTML={{ __html: objectiveNoteText || '' }}></p>}
                        </div>
                    </div>}
                </div>}
            {(selectedItems?.assessment) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">ASSESSMENT</p>
                    </div>
                    <div>
                        {isVisuallyEmpty(assesmentNoteText) ?
                            noValExistText :
                            <p className="text text-black" dangerouslySetInnerHTML={{ __html: assesmentNoteText }}></p>}
                    </div>
                </div>}
            {(selectedItems?.plan || selectedItems?.planNotes || selectedItems?.homeExerciseProgram || selectedItems?.followUp) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">PLAN</p>
                    </div>

                    {selectedItems?.planNotes &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                            <div>
                                {isVisuallyEmpty(planNoteText) ?
                                    noValExistText :
                                    <p className="text text-black" dangerouslySetInnerHTML={{ __html: planNoteText }}></p>}
                            </div>
                        </div>}
                    {selectedItems?.homeExerciseProgram &&
                        <div>
                            <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3 '>Home Exercise Program(HEP)</p>
                            <div>
                                {isVisuallyEmpty(Data.HomeExerciseProgram) ?
                                    noValExistText :
                                    <p className="text" dangerouslySetInnerHTML={{ __html: homeExerciseProgramNoteText }}></p>}
                            </div>
                        </div>}
                    {selectedItems?.followUp &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Follow-Up</p>
                            {isVisuallyEmpty(Data.FollowUpNotes) && !(Data?.FollowUpDate) ?
                                noValExistText :
                                <div>
                                    <div className="d-flex gap-1 text-nowrap mb-1">
                                        <p className='heading'>Follow-Up Date:</p>
                                        <p className='text'>{Data?.FollowUpDate || <span className="text ar-light-color">N/A</span>},</p>
                                    </div>
                                    <div className="d-flex flex-column gap-1">
                                        <p className='heading lh-12'>Notes:</p>
                                        {isVisuallyEmpty(Data.FollowUpNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: followUpNotesText }}></p>}
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>}
            {selectedItems?.customTemplateClinical &&
                (CustomTemplateData?.InsertPosition === "Bottom" ?
                    <CustomTemplateFormPreview CustomTemplateData={CustomTemplateData}/> : <></>)}
            {(selectedItems?.additionalInfo || (selectedItems?.documents || selectedItems?.additionalNotes)) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">Additional INFO</p>
                    </div>
                    {selectedItems?.documents &&
                        <div>
                            <p class="heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black">Documents</p>
                            {Data?.EncounterDocument?.length > 0 ?
                                <div className="d-flex flex-column gap-1">
                                    {Data.EncounterDocument.map((doc) => (
                                        <div className="d-flex align-items-center gap-1">
                                            <p className='text font-m validate-color'>{doc.FileName}</p>
                                            <p className="text text-black">{doc.Description && `- ${doc.Description}`}</p>
                                        </div>
                                    )
                                    )}
                                </div> :
                                <>{noValExistText}</>}
                        </div>}
                    {selectedItems?.additionalNotes &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                            <div>
                                {isVisuallyEmpty(additionalNoteText) ?
                                    noValExistText :
                                    <p className="text text-black" dangerouslySetInnerHTML={{ __html: additionalNoteText }}></p>}
                            </div>
                        </div>}
                </div>}
            {selectedItems?.procedureCodes &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex">
                        <p class="text fs-14 font-b validate-color blue-bg">Procedure Codes</p>
                    </div>
                    {Data?.mainServiceLineModal?.length > 0 ?
                        <div className="d-flex flex-column gap-1">
                            {Data.mainServiceLineModal.map((data) => {
                                let modifiersExists = [data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4].filter(Boolean)?.length > 0;
                                return (
                                    <div className="d-flex align-items-center gap-1 flex-wrap">
                                        <p className='text font-m validate-color'>{data?.ProcedureCode}</p>
                                        {data?.ProcedureDescription ? <p className="text text-black">{data?.ProcedureDescription && `- ${data.ProcedureDescription}`}</p> : null}
                                        {modifiersExists ?
                                            (<div className="d-flex align-items-center gap-1">
                                                <p className="text text-black font-m">Modifiers:</p>
                                                <p className="heading text-black">
                                                    {[data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4]
                                                        .filter(Boolean).join(', ')}
                                                    {data?.Units && !['1', 1, '1.00'].includes(data.Units) && ', '}
                                                </p>
                                            </div>) : <></>}
                                        {((data?.Units) && !['1', 1, "1.00"].includes(data.Units)) ?
                                            (<div className="d-flex align-items-center gap-1">
                                                <p className="text text-black font-m">Units:</p>
                                                <p className="heading text-black">
                                                    {data?.Units}
                                                </p>
                                            </div>) : <></>}
                                    </div>
                                )
                            }
                            )}
                        </div> :
                        <>{noValExistText}</>}

                </div>}
            {isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus) ?
                <div className="d-flex ">
                    <div className="ar-sign-new-design d-flex flex-column gap-1">
                        <div className="">
                            <SignImagePreview BucketPath={data?.Data?.SignaturePath} />
                        </div>
                        <p className="heading text-black">Electronically Signed By/Date:</p>
                        <p className='heading green-text'>{data?.Data?.ProviderSignBy || 'N/A'} on {signatureDateTimeFormatted || 'N/A'}</p>
                        {/* <div className="d-flex align-items-center gap-1">
                            <p className='heading text-black'>Sign Off Status:</p>
                            {(searchValue?.EncounterStatus === 'Signed' || isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus)) ?
                                <p className='Paid heading font-m ar-status-clm'>Signed</p> :
                                searchValue?.EncounterStatus === 'In Progress' ?
                                    <p className='Blue-Status heading font-m ar-status-clm'>In Progress</p> :
                                    searchValue?.EncounterStatus === 'Ready for Review' ?
                                        <p className='In-Review heading font-m ar-status-clm'>Ready for Review</p> :
                                        ['Unsigned', 'UnSigned'].includes(searchValue?.EncounterStatus) &&
                                        <p className='Not-Signed heading font-m ar-status-clm'>Unsigned</p>}
                        </div> */}
                    </div>
                </div>
                :
                null}
                
            {EncounterCoSignData?.map(it => 
                <SignData data={it}/>
            )}
            <div className='text-center pt-1-5 br-top-1 za_br_light'>
                <p className="text ar-light-color">Note Generated by {ThemeConfiguration?.configuration?.company?.name} (<a href="https://starhealthcare.co" className="ar-hover-text ar-light-color text" target="_blank" rel="noopener noreferrer" >https://starhealthcare.co</a>)</p>
                {/* <p className="text ar-light-color">Generated for Printing on: {formattedUTC}</p>
                <p className="text ar-light-color">Generated for Printing on: 11/6/2025 at 09:50 AM UTC</p> */}
                <p className="text ar-light-color">Printed by {data?.Data?.UserName || 'N/A'} on {formattedUTC}</p>
                {/* <p className="text ar-light-color">Generated for Printing on: {formattedUTCBottom}</p> */}
            </div>
        </div >
    </>)
}
export default SelectedPreviewDataV2